/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Tlm_1Inputs */

const en_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const ar_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سطح الواجهة البرمجية`)
};

const bn_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const de_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const es_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_superficie`)
};

const fr_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const pt_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`superfície_api`)
};

const zh_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const tr_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const ru_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

const pl_svc_backend_development_tlm_1 = /** @type {(inputs: Svc_Backend_Development_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`api_surface`)
};

/**
* | output |
* | --- |
* | "api_surface" |
*
* @param {Svc_Backend_Development_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_tlm_1 = /** @type {((inputs?: Svc_Backend_Development_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_tlm_1(inputs)
	if (locale === "bn") return bn_svc_backend_development_tlm_1(inputs)
	if (locale === "de") return de_svc_backend_development_tlm_1(inputs)
	if (locale === "es") return es_svc_backend_development_tlm_1(inputs)
	if (locale === "fr") return fr_svc_backend_development_tlm_1(inputs)
	if (locale === "pt") return pt_svc_backend_development_tlm_1(inputs)
	if (locale === "zh") return zh_svc_backend_development_tlm_1(inputs)
	if (locale === "tr") return tr_svc_backend_development_tlm_1(inputs)
	if (locale === "ru") return ru_svc_backend_development_tlm_1(inputs)
	if (locale === "pl") return pl_svc_backend_development_tlm_1(inputs)
	return en_svc_backend_development_tlm_1(inputs)
});
export { svc_backend_development_tlm_1 as "svc_backend-development_tlm_1" }